var ActionGuide = {
  steps: {
    viewby: {
      key: 'viewby',
      context: 'home',
      attach: {
        target: 'lf-filter-tree header',
        location: 'right-top'
      },
      watch: {
        target: 'lf-filter-tree header .uib-dropdown-menu',
        event: 'click'
      },
      hintStyle: {
        left: '10px',
        top: '25px',
        transform: 'rotate(90deg)',
        animationName: 'hintLeft'
      }
    },
    selection: {
      key: 'selection',
      context: 'home',
      attach: {
        target: 'lf-filter-tree .filter-body',
        location: 'right-top'
      },
      watch: {
        target: 'lf-filter-tree .filter-body',
        event: 'click'
      },
      hintStyle: {
        left: '10px',
        top: '10px',
        transform: 'rotate(90deg)',
        animationName: 'hintLeft'
      }
    },
    format: {
      key: 'format',
      context: 'home',
      attach: {
        target: '#fact-view-toggle',
        location: 'bottom-left'
      },
      watch: {
        target: '#fact-view-toggle',
        event: 'click'
      },
      hintStyle: {
        left: '100px',
        top: '5px',
        transform: 'rotate(180deg)',
        animationName: 'hintTop'
      }
    },
    columns: {
      key: 'columns',
      context: 'home',
      attach: {
        target: '#column-visibility-toggle',
        location: 'left-top'
      },
      watch: {
        target: '#column-visibility-toggle .uib-dropdown-menu',
        event: 'click'
      },
      hintStyle: {
        right: '10px',
        top: '5px',
        transform: 'rotate(-90deg)',
        animationName: 'hintRight'
      }
    },
    generate: {
      key: 'generate',
      context: 'home',
      attach: {
        target: '#link-generate',
        location: 'bottom-right'
      },
      watch: {
        target: '#link-generate',
        event: 'click'
      },
      hintStyle: {
        right: '43px',
        top: '5px',
        transform: 'rotate(180deg)',
        animationName: 'hintTop'
      }
    },
    case: {
      key: 'case',
      context: 'home',
      attach: {
        target: '[ng-click="caseModal()"]',
        location: 'bottom-left'
      },
      watch: {
        target: 'window',
        event: 'hashchange'
      },
      hintStyle: {
        left: '50px',
        top: '5px',
        transform: 'rotate(180deg)',
        animationName: 'hintTop'
      }
    },
    fact: {
      key: 'fact',
      context: 'home',
      attach: {
        target: '#link-add-fact',
        location: 'bottom-right'
      },
      watch: {
        target: '#link-add-fact',
        event: 'click'
      },
      hintStyle: {
        right: '43px',
        top: '5px',
        transform: 'rotate(180deg)',
        animationName: 'hintTop'
      },
      skipComplete: true
    },
    paste: {
      key: 'paste',
      context: 'fact',
      attach: {
        target: 'trix-editor',
        location: 'top-left'
      },
      watch: {
        target: 'trix-editor',
        event: 'trix-paste'
      },
      hintStyle: {
        left: '15px',
        bottom: '5px',
        animationName: 'hintBottom'
      },
      manualPosition: true,
      elementStyle: {
        top: '48px',
        left: '112px'
      }
    },
    save: {
      key: 'save',
      context: 'fact',
      attach: {
        target: '#add-fact',
        location: 'bottom-right'
      },
      watch: {
        target: '#add-fact',
        event: 'click'
      },
      hintStyle: {
        right: '18px',
        top: '5px',
        transform: 'rotate(180deg)',
        animationName: 'hintTop'
      }
    },
    navHome: {
      key: 'navHome',
      context: 'fact',
      attach: {
        target: '[ng-click="$ctrl.onOpenCase()"]',
        location: 'bottom-left'
      },
      watch: {
        target: '[ng-click="$ctrl.onOpenCase()"]',
        event: 'click'
      },
      hintStyle: {
        left: '20px',
        top: '5px',
        transform: 'rotate(180deg)',
        animationName: 'hintTop'
      },
      skipComplete: true
    },
    conclusion: {
      key: 'conclusion',
      context: 'home',
      attach: {
        target: '.navbar-admin',
        location: 'top-center'
      },
      watch: {
        target: 'body',
        event: 'click'
      },
      cta: 'Finish',
      complete: true
    },
    close: {
      key: 'close',
      context: 'home',
      attach: {
        target: '#nav-item-info',
        location: 'left-top'
      },
      watch: {
        target: '[ng-click="actionGuide.finish()"]',
        event: 'click'
      },
      hintStyle: {
        right: '10px',
        top: '5px',
        transform: 'rotate(-90deg)',
        animationName: 'hintRight'
      },
      cta: 'Close',
      skipComplete: true
    }
  },
  guides: {
    full: [
      'viewby', 'selection',
      'format', 'columns', 'generate',
      'case', 'fact', 'paste', 'save', 'navHome'
    ],
    analysis: ['viewby', 'selection'],
    output: ['format', 'columns', 'generate'],
    input: ['case', 'fact', 'paste', 'save', 'navHome']
  }
};

export default angular.module('contants.action-guide', [])
  .constant('ActionGuide', ActionGuide)
  .name;



// WEBPACK FOOTER //
// ./project/constants/action-guide.js